import { useToggle } from 'ahooks';
import type { ElementRef, MutableRefObject } from 'react';
import { useEffect, useState } from 'react';

type IProps = {
  data?: API.BrandVO[] | API.DisplayCategory[];
  wrapperRef?: MutableRefObject<ElementRef<'div'> | null>;
  collapsedSize?: number;
};

export const useCollapse = ({
  data,
  wrapperRef,
  collapsedSize = 0,
}: IProps) => {
  const [more, setMore] = useState(false);
  const [expand, { toggle }] = useToggle(false);

  useEffect(() => {
    const wrapper = wrapperRef?.current;
    if (wrapper) {
      const wrapperHeight = wrapper.offsetHeight;
      if (wrapperHeight > collapsedSize) {
        setMore(true);
      }
    }
  }, [data]);

  return {
    more,
    expand,
    toggle,
  };
};
